import type { Game } from './core/Game';
import type { UI } from './ui/UI';
import type { WorldScene } from './world/WorldScene';

/** Shared handles so the Phaser scene and the DOM UI can reach each other. */
export const app: { game: Game; ui: UI; scene: WorldScene | null } = {
  game: null as unknown as Game,
  ui: null as unknown as UI,
  scene: null,
};
